<div class="page-container">
  <div class="page-content">
    <p class="escolha-contato">
      Para sua proteção
      <strong>escolha um dos meios de contato</strong>
      abaixo e receba o código para alterar sua senha com segurança.
    </p>

    <app-skeleton *ngIf="!userInfo" height="3.625rem" margin="1.5rem 0 0"></app-skeleton>

    <button *ngIf="userInfo && userInfo.email" (click)="selectVerificationMethod(TipoValidacaoCadastral.EMAIL)" mat-stroked-button class="outlined" class="method-selection-btn">
      <mat-icon class="material-symbols-outlined">email</mat-icon>
      <span class="method-data">{{userInfo.email}}</span>
    </button>
    
    <div *ngIf="isInternal && userInfo && !userInfo.email" class="no-email">
      <p>
        O <strong>e-mail</strong> será usado para recuperar sua conta.
        Caso, por exemplo, você esqueça sua senha.
      </p>
      <div class="link-container">
        <mat-icon class="material-symbols-outlined">email</mat-icon>
        <a class="link" href="javascript:void" (click)="showUpdateEmailModal()">Adicionar e-mail</a>
      </div>
    </div>
    
    <p *ngIf="userInfo && userInfo.email && isInternal" class="recuperacao-link">Não possui mais acesso a este e-mail?
      <a class="link" href="javascript:void" (click)="showUpdateEmailModal()">Clique aqui</a> para alterar
    </p>
    
    <app-skeleton *ngIf="!userInfo" height="3.625rem" margin="1.5rem 0 0"></app-skeleton>

    <button  *ngIf="userInfo && userInfo.phone" mat-stroked-button class="outlined" (click)="selectVerificationMethod(TipoValidacaoCadastral.PHONE)" class="method-selection-btn">
      <mat-icon class="material-symbols-outlined">smartphone</mat-icon>
      <span class="method-data">{{userInfo.phone}}</span>
    </button>

    <p *ngIf="isInternal" class="recuperacao-link">Este não é o seu número de celular?
      <a class="link" href="javascript:void" (click)="showUpdatePhoneModal()">Clique aqui</a> para alterar
    </p>

    <p *ngIf="!isInternal" class="recuperacao-link">Não acessa mais esse e-mail e celular, você pode
      <a class="link" href="javascript:void" (click)="goToAccountRecovery()">tentar de outro jeito</a>
    </p>
  </div>
</div>